import { addNavMenuItem, addNavMenuSection, PageLocationId, registerPageTab } from "@bb-vendure/admin-ui/core";
import { PurchaseInboundingPage } from "./components/inbound/Home/page.component";

export default [
  addNavMenuItem(
    {
      id: "inbounding",
      label: "nav.purchase-inbounding-list",
      icon: "bundle",
      routerLink: ["/extensions/inbounding"],
      requiresPermission: (userPermissions) => {
        return userPermissions.includes("ReadInbounding");
      },
    },
    "purchase-request"
  ),

  registerPageTab({
    location: "inbounding-list" as PageLocationId,
    tab: "nav.waiting",
    route: "/extensions/inbounding/waiting",
    //tabIcon: "star",
    component: PurchaseInboundingPage,
  }),
  registerPageTab({
    location: "inbounding-list" as PageLocationId,
    tab: "nav.complete",
    route: "/extensions/inbounding/complete",
    //tabIcon: "star",
    component: PurchaseInboundingPage,
  }),
  registerPageTab({
    location: "inbounding-list" as PageLocationId,
    tab: "nav.confirm",
    route: "/extensions/inbounding/confirm",
    //tabIcon: "star",
    component: PurchaseInboundingPage,
  }),

  addNavMenuSection(
    {
      id: "inbound-section",
      label: "nav.inbounding",
      items: [
        {
          id: "inbound-request",
          label: "nav.inbounding-request-list",
          icon: "bundle",
          routerLink: ["/extensions/inbound-request"],
          requiresPermission: (userPermissions) => {
            return userPermissions.includes("ReadInboundingApproval");
          },
        },
        {
          id: "inbound-complete",
          label: "nav.inbounding-complete-list",
          icon: "bundle",
          routerLink: ["/extensions/inbound-complete"],
          requiresPermission: (userPermissions) => {
            return userPermissions.includes("ReadInboundingApproval");
          },
        },
      ],
    },
    "package-section"
  ),
];
